<template>
    <div>

        <!-- settings -->
        <div class="TQ_padding_16px">

            <!-- choose currency-->
            <div class="TQ_margin_8px TQ_inline">

                <div class="TQ_text_bold TQ_align_initial">
                    {{ass_strings.oneWord_currency[p_system_langCode_e]}}
                </div>

                <tq-dropdown :style-select="true" class="TQ_width_150px">
                    <div slot="select" class="TQ_padding_4px">
                        {{format_costCurrency(selectedCurrency_e)}}
                    </div>

                    <div slot="options"
                         class="TQ_padding_4px"
                         @click="m_changeCurrency_f(currency_e)"
                         v-for="currency_e in enum_cost_currency_n">
                        {{format_costCurrency(currency_e)}}
                    </div>
                </tq-dropdown>
            </div>

            <!-- ticket type -->
            <div class="TQ_margin_8px TQ_inline TQ_text_capitalize">

                <div class="TQ_text_bold TQ_align_initial">
                    {{ass_strings.twoWords_ticketsType[p_system_langCode_e]}}
                </div>

                <tq-dropdown :style-select="true" class="TQ_width_200px">
                    <div slot="select" class="TQ_padding_4px">
                        {{format_ticketType_fs(p_qex_metadata_c.qexm_availableTicketsType_e, p_system_langCode_e)}}
                    </div>

                    <div slot="options"
                         class="TQ_padding_4px"
                         @click="p_qex_metadata_c.qexm_availableTicketsType_e = ticketType_e"
                         v-for="ticketType_e in enum_availableTicketsTypes_s">
                        {{format_ticketType_fs(ticketType_e, p_system_langCode_e)}}
                    </div>
                </tq-dropdown>
            </div>

        </div>
        <hr>

        <!-- tickets -->
        <div v-for="(qet_availableTicket_c,index) in p_qex_availableTickets_ac" :key="index"
             class="TQ_verticalAlignTop TQ_box_shadow TQ_maxWidth_250px TQ_inline TQ_margin_8px TQ_padding_8px TQ_border TQ_borderRadius">

            <div class="TQ_grid_col_auto1fr TQ_grid_gap_8px ">

                <tq-pick-color :p_system-lang-code_e="p_system_langCode_e"
                               :pe_change-color_s="(newColor_s) => {qet_availableTicket_c.qexa_ticketColor_s=newColor_s}"
                               class=" TQ_grid_verticalCenter"
                               :p_init-color_s="qet_availableTicket_c.qexa_ticketColor_s">

                    <si_ticket-colorful class="TQ_width_32px TQ_box_shadow TQ_padding_8px TQ_borderRadius TQ_border TQ_clickable"
                                        :p_fill_s="qet_availableTicket_c.qexa_ticketColor_s"/>
                </tq-pick-color>


                <div class="ticket">

                    <div class="name TQ_text_bold">{{ass_strings.oneWord_players[p_system_langCode_e]}}:</div>
                    <div class="spots">
                        <input type="number"
                               @change="m_newSpotsInputCheck_f(qet_availableTicket_c)"
                               v-model.number="qet_availableTicket_c.qexa_spots_n"
                               :min="1"/>
                    </div>

                    <div class="name TQ_text_bold">{{ass_strings.oneWord_cost[p_system_langCode_e]}}:</div>
                    <div class="cost">
                        <input type="number"
                               @change="m_newCostInputCheck_f(qet_availableTicket_c.qexa_cost_c)"
                               v-model.number="qet_availableTicket_c.qexa_cost_c.c_value_n"
                               :min="gv_numbers.minPrice_newTicket"/>

                        <div class="TQ_padding_4px">
                            {{format_costCurrency(qet_availableTicket_c.qexa_cost_c.c_currency_e)}}
                        </div>


                    </div>
                </div>
            </div>

            <div class="TQ_margin_top_8px" v-if="co_showDescription_b">

                <div v-for="langCode_e in p_qex_langArr_ae">
                    <div class="TQ_text_bold">
                        {{format_langCode_fs(langCode_e)}}
                    </div>
                    <tq-textarea
                        :style="{'direction' : helper_getDirectionByLangCode_fe(langCode_e)}"
                        :pb_uid_s="'TqTextarea' + index"
                        pb_textarea-class_s="TQ_padding_4px "
                        :pb_init-text_s="qet_availableTicket_c.qexa_description_blc_s[langCode_e]"
                        :pb_max-length_n="50"
                        :pb_placeholder_s="ass_strings.oneWord_description[langCode_e]"
                        :pb_rows_n="3"
                        :pe_change-text_s="(text_s) => {$set(qet_availableTicket_c.qexa_description_blc_s, langCode_e, text_s)}"
                    />

                </div>

            </div>

            <hr>
            <div class="lc_deleteTicketBtn TQ_padding_4px TQ_text_20px TQ_clickable" @click="p_qex_availableTickets_ac.splice(index,1)"> {{ass_strings.oneWord_delete[p_system_langCode_e]}} </div>

        </div >

        <!-- new tickets -->
        <div class='TQ_verticalAlignTop TQ_inline TQ_box_shadow TQ_margin_8px TQ_clickable TQ_bg_hover_goldLite TQ_borderRadius'
             :class="co_showDescription_b ? 'lc_addTicketBtnBig' : 'lc_addTicketBtnSmall'"
             @click="m_addNewTicket_f">
            <img :src="ass_img_ticket4_p" class="TQ_width_52px"/>
            <div>{{ass_strings.twoWords_newTicket[p_system_langCode_e]}}</div>
        </div>


    </div>
</template>

<script>
import {
    FB_QuestExplore_AvailableTickets,
    FB_QuestExplore_Metadata
} from "../../../../../functions/src/shareCode/Share_S_Classes";
import {
    format_costCurrency,
    format_langCode_fs,
    format_ticketType_fs
} from "../../../../../functions/src/shareCode/Share_S_Format";
import {enum_availableTicketsTypes_s, enum_costCurrency_n} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqDropdown from "../../../../components/basic/TqDropdown";
    import {validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {ass_img_ticket4_p} from "../../../../assets/scripts/Ass_Files";
    import {gv_numbers} from "../../../../../functions/src/shareCode/Share_Ass_GlobalVariable";
    import TqTextarea from "../../../../components/basic/TqTextarea";
    import Si_ticketColorful from "../../../../components/a_smartIcons/si_ticketColorful";
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
import TqPickColor from "@/components/basic2/TqPickColor";
import {helper_getDirectionByLangCode_fe} from "@/scripts/S_Helper";

    export default {
        name: "c_Creator_EditQuests_Item_ExploreTickets",
        components: {
            TqPickColor,
            Si_ticketColorful,
            TqTextarea,
            TqDropdown,
        },
        props:{
            p_qex_langArr_ae:{
                type: Array,
                require: true,
            },
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_system_currency_e:{
                type: Number,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_costCurrency_n, val)
                }
            },
            p_qex_metadata_c:{
                type: FB_QuestExplore_Metadata,
                require: true,
            },
            p_qex_availableTickets_ac:{
                type: Array,
                require: true,
            },

        },
        data(){
            return {

                selectedCurrency_e : null,

                enum_cost_currency_n: enum_costCurrency_n,
                enum_availableTicketsTypes_s: enum_availableTicketsTypes_s,

                ass_strings : ass_strings,
                ass_img_ticket4_p : ass_img_ticket4_p,
                gv_numbers : gv_numbers,

                helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe,

                format_costCurrency : format_costCurrency,
                format_langCode_fs: format_langCode_fs,
                format_ticketType_fs: format_ticketType_fs,

            }
        },
        computed:{
            co_showDescription_b(){
                return this.p_qex_metadata_c.qexm_availableTicketsType_e === enum_availableTicketsTypes_s.specificTicket
            }
        },
        methods:{

            m_addNewTicket_f(){
                let newCoupon = new FB_QuestExplore_AvailableTickets({})
                this.p_qex_availableTickets_ac.push(newCoupon)
            },

            m_newCostInputCheck_f(cost_c){
                if(cost_c.c_value_n < gv_numbers.minPrice_newTicket){
                    cost_c.c_value_n = gv_numbers.minPrice_newTicket
                }else{
                    cost_c.c_value_n = Math.floor(cost_c.c_value_n)
                }
            },

            m_newSpotsInputCheck_f(qet_availableTicket_c){
                if(qet_availableTicket_c.qexa_spots_n  < 1){
                    qet_availableTicket_c.qexa_spots_n = 1
                }else{
                    qet_availableTicket_c.qexa_spots_n = Math.floor(qet_availableTicket_c.qexa_spots_n)
                }

            },

            m_changeCurrency_f(newCurrency_e){
                this.selectedCurrency_e = newCurrency_e

                this.p_qex_availableTickets_ac.forEach(qex_availableTicket_c => {
                    qex_availableTicket_c.qexa_cost_c.c_currency_e = newCurrency_e
                })
            }
        },

        mounted(){
            if(this.p_qex_availableTickets_ac.length === 0){
                this.selectedCurrency_e = this.p_system_currency_e;
            }else{
                this.selectedCurrency_e = this.p_qex_availableTickets_ac[0].qexa_cost_c.c_currency_e
            }
        }

    }
</script>

<style scoped lang="scss">


    .lc_addTicketBtnBig{
        font-size: 20px;
        padding: 60px 50px;
        border: 1px solid black;
        line-height: 40px;
    }
    .lc_addTicketBtnSmall{
        font-size: 20px;
        padding: 30px 50px;
        border: 1px solid black;
        line-height: 20px;
    }


    .ticket{

        display: grid;
        grid-template-columns: auto 1fr;
        padding: 4px 0px;
        grid-column-gap: 4px;
        grid-row-gap: 8px;
        width: 100%;


        .name{
            align-self: center;
        }

        .spots{
            input{
                width: calc(100% - 4px);
                text-align: center;
                padding: 4px 0px;
            }
        }

        .cost{
            width: 100%;
            display: grid;
            grid-template-columns: 1fr auto;
            grid-column-gap: 4px;

            input{
                width: calc(100% - 4px);
                text-align: center;
            }

            .dropdown{
                border:1px solid black;

                .select{
                    width: 20px;
                    padding: 4px 0px;
                }

                .options{
                    padding : 4px;
                    border-top: 1px solid black;

                    &:last-child{
                        border-bottom: 1px solid black;
                    }
                }
            }

        }

    }


    .lc_deleteTicketBtn{
        background: var(--color-red);
        color: white;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);

    }


</style>
